import React, { Component } from "react";
import NavLink from "../components/NavLink";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { login } from "../actions/accountActions";
import { withTranslation } from 'react-i18next';
import { utils } from "../common/utils";

import { SitePageContentTypeEnum } from "../common/enums";
class MainNav extends Component {

    //constructor(props) {
    //    super(props);
    //    const { user, match } = props;
    //    if (!user.isAuthenticated) {
    //        axios.defaults.headers.common['shopName'] = match.params.shopName ? match.params.shopName : "";
    //    }

    //}

    render() {
        // const { t } = useTranslation();
        const { t, settings, siteLinks, locale } = this.props;
       // const baseUrl = this.props.match.params.shopName ? `/${this.props.match.params.shopName}/` : "/";
        let linkIndex = 0;

        const localeTopMenuLinks = siteLinks && siteLinks.topMenuLinks ? siteLinks.topMenuLinks.filter(link => (utils.isNullOrEmpty(link.locale) || link.locale === locale)) : [];
        const topMenuLinks = localeTopMenuLinks.map(link => {
            if (link.contentType === SitePageContentTypeEnum.Url) {
                
                return (
                    <li key={++linkIndex}>
                        <a rel="noopener noreferrer" target={link.target}
                            href={utils.getLinkUrl(link, settings)}>
                            <span>{link.name}</span></a>
                    </li>
                );
            } else {
                return (<NavLink key={++linkIndex} location={this.props.location} className='offcanvas-menu-link'
                        to={`${settings.baseUrl}page/${link.id}`} >{link.name}
                </NavLink>);
            }
        });

        return (
            <nav className="site-menu">
                <ul>
                    <NavLink to={`${settings.baseUrl}`} location={this.props.location}  props={{ className: 'home-link' }} exact>
                        {t("Home")}
                    </NavLink>
                    <NavLink to={`${settings.baseUrl}categories`} location={this.props.location}   exact>
                        {t("Categories")}
                    </NavLink>
                    <NavLink to={`${settings.baseUrl}cart`} location={this.props.location}  props={{ className: 'cart-link' }} exact>
                        {t("Cart")}
                    </NavLink>
                    {settings.isPersonalisedSite && <NavLink to={`${settings.baseUrl}about`} location={this.props.location}  exact>
                        {t("About Me")}
                    </NavLink>}
                    {topMenuLinks}
                </ul>
            </nav>
        );
    }
}



function mapStateToProps(state, ownProps) {
    return { user: state.user, settings: state.settings, siteLinks: state.siteLinks, locale: state.locale, ...ownProps };
}

export default withTranslation()(withRouter(connect(mapStateToProps, { login })(MainNav)));

